import { CameraIcon } from "../../SvgIcons/CameraIcon";
import { CameraOffIcon } from "../../SvgIcons/CameraOffIcon";

interface ButtonProps {
  isOn: boolean;
  onClick: () => void;
}

// Camera Button
const CameraButton: React.FC<ButtonProps> = ({ isOn, onClick }) => (
  <button
    onClick={onClick}
    className={`w-14 h-14 text-white text-xl rounded-2xl flex justify-center align-middle items-center transition ${
      !isOn ? "bg-[#7E57C2] hover:bg-[#6846a1]" : "bg-[#555] hover:bg-[#666]"
    }`}
  >
    {isOn ? <CameraIcon size={20} /> : <CameraOffIcon size={20} />}
  </button>
);

export default CameraButton;
